module.exports = __webpack_public_path__ + "static/media/New.375173c3.svg";